const baseAnchorData = { anchor: '' };
export const AnchorData = {
    fromJSON(object) {
        const message = Object.assign({}, baseAnchorData);
        message.anchor =
            object.anchor !== undefined && object.anchor !== null ? String(object.anchor) : '';
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.anchor !== undefined && (obj.anchor = message.anchor);
        return obj;
    },
};
//# sourceMappingURL=decoration_anchor.js.map